export default __webpack_public_path__ + "02b31a420e708a6600c02600614c8c2e.png";